import React from 'react';
import PropTypes from 'prop-types';
import SkeletonLoader from './SkeletonLoader';
import './SkeletonLoader.css';

/**
 * Skeleton placeholder for profile/info cards (GlassCard style).
 * Renders a header bar + rows of label/input pairs.
 *
 * @param {Object} props
 * @param {number} [props.count=1] - Number of card skeletons to render
 */
const CardSkeleton = ({ count = 1 }) => {
  const ids = Array.from({ length: count }, (_, i) => `card-skel-${i}`);
  return (
    <>
      {ids.map((id) => (
        <div className="skeleton-card" key={id}>
          {/* Card header bar */}
          <SkeletonLoader width="100%" height="48px" borderRadius="0" />
          {/* Field rows: label + input pairs */}
          <div className="skeleton-group">
            {[70, 50, 85, 60].map((inputWidth) => (
              <div className="skeleton-row" key={`row-${inputWidth}`}>
                <SkeletonLoader width="30%" height="16px" />
                <SkeletonLoader width={`${inputWidth}%`} height="16px" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

CardSkeleton.propTypes = {
  count: PropTypes.number,
};

export default CardSkeleton;
